import clsx from 'clsx';
import * as React from 'react';
export { L as Logo } from '../../Logo-a30b3a4c.js';
import { S as StyledHeader } from '../../styles-a84844f7.js';
import '../../_tslib-4c7d6ae2.js';
import 'styled-components';

var Variants;
(function (Variants) {
    Variants["PRINCIPAL"] = "";
    Variants["SUBHEADER"] = "--subheader";
    Variants["CATEGORIES"] = "--categories";
    Variants["DEALS"] = "--deals";
})(Variants || (Variants = {}));
var Header = function (_a) {
    var children = _a.children, Variant = _a.Variant, Categories = _a.Categories, SelectedCategory = _a.SelectedCategory, categoryMenuRef = _a.categoryMenuRef, SiblingElements = _a.SiblingElements;
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledHeader, { className: "header ".concat(Variant), style: !Categories ? { height: "auto" } : {} },
            React.createElement("div", { className: "header__actions ".concat(Variant) }, children),
            renderCategoryMenu(Categories, SelectedCategory, categoryMenuRef),
            SiblingElements)));
};
var renderCategoryMenu = function (Categories, selectedCategory, categoryMenuRef) {
    if (!Categories || !Categories.length) {
        return null;
    }
    var isActive = function (label) {
        return label.toLocaleLowerCase() === (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.toLowerCase());
    };
    var renderItem = function (_a) {
        var Label = _a.label, Url = _a.url;
        return (React.createElement("li", { key: "category_".concat(Label) },
            React.createElement("a", { key: "header_categories_".concat(Label), className: clsx("typo-btn-13-reg", { active: isActive(Label) }), href: Url, dangerouslySetInnerHTML: { __html: Label } })));
    };
    return (React.createElement("nav", { className: "header__navigation" },
        React.createElement("div", { className: "header__links-list" },
            React.createElement("ul", { ref: categoryMenuRef, className: "header__container-links" }, Categories.map(renderItem)))));
};

export { Variants, Header as default };
//# sourceMappingURL=index.js.map
